import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  isGiftReturnFromModel,
  validateIsGiftReturnCondition,
  type IsGiftReturnState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const IS_GIFT_RETURN = (
  Details: React.ComponentType<ConditionTypeDetailsProps<IsGiftReturnState>>,
): ConditionType<IsGiftReturnState, Condition.IsGiftReturn> => ({
  name: CONDITION_NAMES[Condition.IS_GIFT_RETURN],
  description(state) {
    return t("Return is a gift return");
  },
  Details(props: ConditionTypeDetailsProps<IsGiftReturnState>) {
    return React.createElement(Details, props);
  },
  empty: false,
  fromModel(model) {
    return isGiftReturnFromModel(model);
  },
  toModel(state) {
    return { type: Condition.IS_GIFT_RETURN };
  },
  valid(state) {
    return validateIsGiftReturnCondition(state).valid;
  },
});
